import { UrlParams, useUrlSearchParams } from '@vueuse/core';
import { watch } from 'vue';

export default function () {
  const urlParams: UrlParams = useUrlSearchParams('hash');

  function setUrlParams(params: UrlParams) {
    // console.log('composable', params);
    Object.entries(params).forEach((param: any) => {
      if (param[1] && param[1].toString() !== '') {
        urlParams[param[0]] = param[1];
      } else {
        delete urlParams[param[0]];
      }
    });
  }
  function deleteUrlParams(params: string[]) {
    params.forEach((param: string) => {
      delete urlParams[param];
    });
  }
  // watch(
  //   () => urlParams,
  //   () => {
  //     console.log('üparar', urlParams);
  //   },
  //   { deep: true }
  // );
  return { setUrlParams, deleteUrlParams, urlParams };
}

// export let params: UrlParams;
